import { gql } from '@apollo/client'

export const API_CLIENTS_LIST = gql`
  query API_CLIENTS_LIST($pagination: PaginationInput, $order: OrderInput) {
    apiClients(pagination: $pagination, order: $order) {
      pagination {
        pageTake
        pageSkip
        totalCount
      }
      data {
        id
        name
        clientId
        scopes
        secretPreview
        secretExpiresAt
        active
        revokedAt
        createdAt
        allowedIpRanges
      }
    }
  }
`
